import React, { useEffect, useRef } from 'react';

interface Base64ToSvgProps {
  logoBase64: string;
  className?: string;
}

export default function Base64ToSvg({ logoBase64, className }: Base64ToSvgProps) {
  const svgContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const svgContainer = svgContainerRef.current;

    if (svgContainer) {
      const decodedSvg = atob(logoBase64);
      const svgElement = new DOMParser().parseFromString(decodedSvg, 'image/svg+xml').documentElement;

      svgContainer.appendChild(svgElement);
    }

    return () => {
      if (svgContainer) {
        svgContainer.innerHTML = '';
      }
    };
  }, [logoBase64]);

  return <div className={className} ref={svgContainerRef} />;
}
